import { enumBoxHeightMode } from "../constants";

export function VSizingModeToStringCode(sizingMode) {
  switch (sizingMode) {
    case enumBoxHeightMode.autoself:
      return "autoself";
      break;
    case enumBoxHeightMode.autosmart:
      return "autosmart";
      break;
  }

  return "Fixed";
}
